/*
 * @Author: Chao Yang
 * @Date: 2020-03-09 11:09:54
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-15 02:08:34
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Account from 'src/app/domain/model/account';
import { BaseProxy } from '../base.proxy';
import { HttpHeaders } from '@angular/common/http';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class ActivityProxy extends BaseProxy {
  getAccountDetailActivityCount(
    programId: number,
    date: number,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<number> {
    return this._http.post<number>(
      '/ip/api/feed/program/' +
        programId +
        '/account/detail/activity/count?lastCheckDate=' +
        date +
        '&endDate=' +
        endDate.getTime(),
      accounts
    );
  }

  getAccountDetailActivity(
    programId: number,
    date: number,
    pageSize: number,
    pageNumber: number,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IActivity[]> {
    return this._http.post<Account.IActivity[]>(
      '/ip/api/feed/program/' +
        programId +
        '/account/detail/activity/page/' +
        pageNumber +
        '/' +
        pageSize +
        '?lastCheckDate=' +
        date +
        '&endDate=' +
        endDate.getTime(),
      accounts
    );
  }

  getLastCheckDate() {
    return this._http.get<number>(`/ip/api/feed/dashboard/activity/date`);
  }

  putLastCheckDate(date: Date) {
    return this._http.put(
      `/ip/api/feed/dashboard/activity/date/${date.getTime()}`,
      {}
    );
  }

  getAccountActivity(
    pageNumber: number,
    pageSize: number,
    lastCheckDate: Date,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IActivity[]> {
    return this._http.post<Account.IActivity[]>(
      `/ip/api/feed/dashboard/activity/page/${pageNumber}/${pageSize}?lastCheckDate=${lastCheckDate.getTime()}&endDate=${endDate.getTime()}`,
      accounts
    );
  }

  getActivityCount(
    lastCheckDate: Date,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<number> {
    return this._http.post<number>(
      `/ip/api/feed/dashboard/activity/count?lastCheckDate=${lastCheckDate.getTime()}&endDate=${endDate.getTime()}`,
      accounts
    );
  }

  createUserDocumentResponse(yesOrNo: boolean, comment: string, id: number) {
    var formData = new FormData();
    formData.set('yesOrNo', yesOrNo + '');
    formData.set('comment', comment + '');
    formData.set('id', id + '');
    return this._http.post(`/ip/api/feed/task/file`, formData);
  }
}
